/**
 * The two backend base URLs, resolved once.
 *
 * apps/tutor owns the live lesson runtime, apps/web everything else, so which
 * host serves a path is a real question. Both values come from Amplify
 * environment variables — nothing in this repo injects VITE_* at build time —
 * so a missing one is a deploy mistake, not a code path.
 *
 * A localhost default in a deployed bundle is worse than it looks: it points
 * every request at the viewer's own machine, so the failure arrives as
 * connection errors in each user's browser. Hence the throw below.
 *
 * The throw is the second line of defence, not the first. Vite never executes
 * module bodies while building, so it cannot fail a build — vite.config.ts
 * checks the same two variables before the bundle is produced.
 */

const resolve = (
  value: string | undefined,
  variableName: string,
  devFallback: string,
): string => {
  if (value) return value;
  if (import.meta.env.DEV) return devFallback;
  throw new Error(
    `${variableName} is not set. It has to exist in the Amplify environment ` +
      `before the build runs — the value is baked in at build time, not read ` +
      `at runtime.`,
  );
};

/** apps/tutor — /session/* and the lesson WebSocket. */
export const TUTOR_BASE_URL = resolve(
  import.meta.env.VITE_BASE_URL,
  "VITE_BASE_URL",
  "http://localhost:8000/api/v1",
);

/** apps/web — every other REST endpoint, plus the SSE stream. */
export const WEB_BASE_URL = resolve(
  import.meta.env.VITE_WEB_BASE_URL,
  "VITE_WEB_BASE_URL",
  "http://localhost:8001/api/v1",
);
